const COMMON_LIMIT = 10;

export class ProductBatchQueryParams {
  /**
   * @param {Object} data
   * @param {String} [data.batchCode]
   * @param {Number[]} [data.storeIds]
   * @param {String} [data.productId]
   * @param {Number} [data.page]
   * @param {Number} [data.limit]
   * @param {Number} [data.size]
   * @param {String} [data.fromDate]
   * @param {String} [data.toDate]
   * @param {String[]} [data.stockStatus] - lọc trạng thái tồn: inStock/transfer/warranty/holding
   */
  constructor(data = {}) {
    this.batchCode = data.batchCode;
    this.storeIds = data.storeIds;
    this.productId = data.productId;
    this.limit = data.limit || COMMON_LIMIT;
    this.page = data.page || 1;
    this.size = data.size || COMMON_LIMIT;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
    this.stockStatus = data.stockStatus;
  }
}
